// Blacklist for the Metal Type noise-filter toggle. Unlike Shape's fixed
// whitelist, metal types aren't a small enumerable set (Gold/Platinum/Silver/
// White Gold/Rose Gold/...), so we flag known junk/blank values instead of
// listing every valid one. Keep in sync with backend Task 1708 (B3 "None"
// normalization) once that lands.
const INVALID_METAL_TYPES = ["none", "n/a", "na", "unspecified", "null", ""];

export const isValidMetalType = (label) =>
  !INVALID_METAL_TYPES.includes(String(label ?? "").trim().toLowerCase());
